import api from './api'

export const petSitterService = {
  /**
   * @param {object} payload - { estilo_perfil?: 'pro'|'onda'|null, empresa?, especialidades?, experiencia_anos? }
   */
  async updateMe(payload) {
    const response = await api.put('/pet-sitter/me', payload)
    return response.data
  },
}
